import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=3015ec8e&scoped=true"
import script from "./accordion.vue?vue&type=script&lang=js"
export * from "./accordion.vue?vue&type=script&lang=js"
import style0 from "./accordion.vue?vue&type=style&index=0&id=3015ec8e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015ec8e",
  null
  
)

export default component.exports